'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (feis) {
  return function (state) {

    var productsStatePath = ['feiseanna', 'products', feis.get('id')];
    var loading = state.getIn([].concat(productsStatePath, ['loading'])) || false;

    return {
      loading: loading
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/products/mapStateToController.js
// module id = 553
// module chunks = 0